export default __webpack_public_path__ + "static/media/profilePicture.c79d32af.svg";